import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useGlobalState } from '../contexts/GlobalContext';
import logo from '../assets/headerButton.png';
import { apiFetch } from '../utils/api';
import FeedbackRequestModal from './FeedbackRequestModal';

function Header() {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobalState();
  const location = useLocation();
  const [showFeedback, setShowFeedback] = useState(false);
  

  const handleLogout = async () => {
    try {
      await apiFetch('logout', { method: 'POST' });
    } catch (e) {
      // ignore errors
    }

    dispatch({ type: 'LOGOUT_USER' });
    navigate('/login');
  };

  const handleProfile = () => {
    navigate(`/profile/${state.user.userId}`);
  };

  return (
    <header
      className="navbar sticky-top flex-md-nowrap p-0 shadow"
      style={{ backgroundColor: 'rgba(1,1,1,1)' }}
    >
      {/* Show logo only if user is signed in */}

      {state.user ? (
        <Link
          className="navbar-brand col-md-3 col-lg-2 me-0 px-3 d-flex align-items-center"
          to="/"
        >
          <img
            src={logo}
            alt="SIGNL Logo"
            style={{ maxHeight: '32px', objectFit: 'contain' }}
          />
        </Link>
      ) : (
        (location.pathname === "/login" || location.pathname === "/signUp" || location.pathname === "/verify-email") && (
          <Link
            className="navbar-brand col-md-3 col-lg-2 me-0 px-3 d-flex align-items-center text-white"
            to="/"
          >
            Back
          </Link>
        )
      )}


      {/* Hamburger Menu */}
      <button
        className="navbar-toggler d-md-none me-3"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Right-aligned navigation */}
      <div className="navbar-nav ms-auto pe-3">
        <div className="nav-item dropdown">
          {state.user ? (
            <>
              <button
                className="nav-link px-3 btn btn-link dropdown-toggle text-white"
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {state.user.firstName || 'User'}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end position-absolute"
                aria-labelledby="userDropdown"
                style={{ top: '100%' }}
              >
                <li>
                  <button className="dropdown-item" onClick={handleProfile}>
                    Profile
                  </button>
                </li>
                <li>
                  <Link className="dropdown-item" to="/account">
                    Account
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/help">
                    Help
                  </Link>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item" onClick={() => setShowFeedback(true)}>
                    Report Bug / Make Suggestion
                  </button>
                </li>
                {/* <li>
                  <button className="dropdown-item" onClick={handleProfile}>
                    Settings
                  </button>
                </li> */}
                <li>
                  <button className="dropdown-item" onClick={handleLogout}>
                    Log Out
                  </button>
                </li>
              </ul>
              <FeedbackRequestModal show={showFeedback} onHide={() => setShowFeedback(false)} />
            </>
          ) : (
            <Link className="nav-link px-3 text-light" to="/login">
              Sign In
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
